import { render } from "./SubscribeModal.vue?vue&type=template&id=322439c2&ts=true"
import script from "./SubscribeModal.vue?vue&type=script&lang=ts"
export * from "./SubscribeModal.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__